'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reduxForm = require('redux-form');
var _times = require('lodash/times');var _times2 = _interopRequireDefault(_times);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _OMTextFieldWithOptionsLang = require('../OMComponents/OMTextFieldWithOptionsLang/OMTextFieldWithOptionsLang');var _OMTextFieldWithOptionsLang2 = _interopRequireDefault(_OMTextFieldWithOptionsLang);

var _EditCompanyByOwnerAdvantages = require('./EditCompanyByOwnerAdvantages.scss');var styles = _interopRequireWildcard(_EditCompanyByOwnerAdvantages);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Styles
var EditCompanyByOwnerAdvantages = function (_Component) {_inherits(EditCompanyByOwnerAdvantages, _Component);function EditCompanyByOwnerAdvantages() {var _temp, _this, _ret;_classCallCheck(this, EditCompanyByOwnerAdvantages);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.




    createEmptyAdvantage = function (idx) {return { id: (Date.now() + idx).toString(16) };}, _this.

    addAdvantage = function (fields) {
      var itemsCount = !fields.length ? 3 : 1;
      var emptyAdvantages = (0, _times2.default)(itemsCount, _this.createEmptyAdvantage);
      emptyAdvantages.forEach(function (item) {return fields.push(item);});
    }, _this.

    renderField = function (field, index, fields) {
      var currentField = fields.get(index);
      var id = currentField.id;
      var removeItem = function removeItem() {return fields.remove(index);};

      return (
        _react2.default.createElement('div', { className: styles.advantage, key: id },
          _react2.default.createElement('div', { className: styles.title },
            _this.props.translate('editOwner', 'advantage'), ' ', index + 1,
            fields.length > 3 && index >= 3 &&
            _react2.default.createElement('i', {
              className: 'icon icon-close',
              onClick: removeItem })),



          _react2.default.createElement('div', { className: styles.itemContent },
            _react2.default.createElement(_OMTextFieldWithOptionsLang2.default, {
              translate: _this.props.translate,
              classNameTabs: 'project-form',
              name: field + '.description',
              locale: _this.props.locale,
              isOptionalLangsDisabled: !(0, _get2.default)(currentField, 'description.he') }))));




    }, _this.

    renderAdvantages = function (data) {var
      fields = data.fields,error = data.meta.error;
      var addField = function addField() {return _this.addAdvantage(fields);};

      return (
        _react2.default.createElement('div', { className: styles.wrapper },
          fields.map(function (item, idx) {return _this.renderField(item, idx, fields);}),
          fields.length < 6 &&
          _react2.default.createElement('div', { className: styles.addBtnWrapper },
            _react2.default.createElement('button', { type: 'button', className: styles.addBtn, onClick: addField }, '+ ',
              _this.props.translate('editOwner', 'addAdvantages')),

            error && _react2.default.createElement('div', { className: styles.error }, _this.props.translate('editOwner', 'advantagesError')))));




    }, _temp), _possibleConstructorReturn(_this, _ret);}EditCompanyByOwnerAdvantages.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {var isLocaleChanged = nextProps.locale !== this.props.locale;return isLocaleChanged;};EditCompanyByOwnerAdvantages.prototype.

  render = function render() {
    return (
      _react2.default.createElement(_reduxForm.FieldArray, { name: 'advantages', component: this.renderAdvantages }));

  };return EditCompanyByOwnerAdvantages;}(_react.Component);


EditCompanyByOwnerAdvantages.propTypes = {
  translate: _propTypes2.default.func,
  push: _propTypes2.default.func,
  locale: _propTypes2.default.string };exports.default =


EditCompanyByOwnerAdvantages;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EditCompanyByOwnerAdvantages/EditCompanyByOwnerAdvantages.js
// module id = 2657
// module chunks = 0